import { ModifyLimitOrder } from './ModifyLimitOrder';
export class ModifyCareOrder extends ModifyLimitOrder {
    constructor(data, orderType) {
        super(data, orderType);
    }
}
